import type { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import { CROSS_BORDER_COUNTRY_COVERAGE_CENTRE_URL, CROSS_BORDER_COUNTRY_GUIDELINE_URL } from '../../config/constants';

const crossBorderMessageLinkComponents = [
    <a key="country-guideline" href={CROSS_BORDER_COUNTRY_GUIDELINE_URL} target="_blank" rel="noopener noreferrer" />,
    <a key="country-coverage" href={CROSS_BORDER_COUNTRY_COVERAGE_CENTRE_URL} target="_blank" rel="noopener noreferrer" />,
];

export const CrossBorderWarningMessage: FunctionComponent = () => <Trans i18nKey="crossBorderWarningMessage" components={crossBorderMessageLinkComponents} />;
